import { render, staticRenderFns } from "./PublicationChart.vue?vue&type=template&id=7682008e&scoped=true&"
import script from "./PublicationChart.vue?vue&type=script&lang=js&"
export * from "./PublicationChart.vue?vue&type=script&lang=js&"
import style0 from "./PublicationChart.vue?vue&type=style&index=0&id=7682008e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7682008e",
  null
  
)

export default component.exports